import React from 'react';

export default function FaqPage() {
	return (
		<section id="body">
			<div className="container">
				<div className="row shadow title position-relative">
					<div className="col-12">
						<h2 className="text-center m-5 text-white fw-bold">Frequently Asked Questions</h2>
					</div>
				</div>
				<div className="row content">
					<div className="col-1"></div>
					<div className="col-10 shadow bg-white rounded">
												<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">1.</label>
								<label className="col-10 col-form-label">
                                If I am travelling with my friend, do we need to buy separate travel policy?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
                                Yes, both of you need to purchase an individual plan each.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">2.</label>
								<label className="col-10 col-form-label">
                                When should I buy travel insurance?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
                                You should buy your travel insurance before commencement of your journey and it is advisable to start 1 day or earlier before your trip.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">3.</label>
								<label className="col-10 col-form-label">Who is eligible for travel insurance?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">The Policyholder must be a resident of Malaysia, at least 30 days but not more than 80 years old on the Effective Date of Policy, depending on the policy and provider.<br></br>
                                Subject to the Policyholder being covered, the following are also eligible for cover, depending on the policy and provider :-
                                <ul>
                                    <li>Legal Spouse who is a resident of Malaysia, at least 18 years old not more than 80 years old on the Effective Date of Policy</li>
                                    <li>Dependent Children who are residents of Malaysia, at least 30 days of age and not more than 18 years or below 23 years if studying full- time in a recognised tertiary institution on the Effective Date of Policy.</li>
                                </ul>
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">4.</label>
								<label className="col-10 col-form-label">What is Family plan?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">For Family plan, it is essential to include yourself, your spouse and at least one child.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">5.</label>
								<label className="col-10 col-form-label">I am pregnant.  Will I be covered for any pregnancy-related matters while I am overseas?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
                                No, the policy does not cover any pregnancy-related issues other than accidental miscarriage due to bodily injury as a result of an accident.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">6.</label>
								<label className="col-10 col-form-label">Do I need to undergo medical examination to apply for my Travel Insurance?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
                                No. However, please note that there are exclusions on pre-existing medical conditions. Please refer to Policy Wording for full details. 
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">7.</label>
								<label className="col-10 col-form-label">What does pre-existing condition mean?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								Pre-existing condition mean a medical condition that started before a person’s insurance went into effect.
								</label>

							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">8.</label>
								<label className="col-10 col-form-label">Does travel insurance cover natural disasters?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								Most of the travel insurance cover natural disasters and subject to the terms of the policy. It is important to compare your travel insurance.
							</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">9.</label>
								<label className="col-10 col-form-label">How long does travel insurance last?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
                                Some of the insurance company cover up to 190 days for single trip and 90 days for annual trip cover. It is important to consult Howden Insurance Broker or refer to Product Brochure or Policy Wording from the respective insurance companies.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">10.</label>
								<label className="col-10 col-form-label">Can I cancel travel insurance if I cancel my trip?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
                                You may terminate the policy at any time by giving a written notice to the company within fourteen (14) days or contact our Customer Service Centre here. Such termination shall become effective on the date the notice is received by the Company or the date specified in the notice, whichever is earlier. No premium will be refunded upon cancellation of cover.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">11.</label>
								<label className="col-10 col-form-label">What happen if I booked my trip but could not go because I can’t get an entry visa in time?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
                                The policy excludes prohibition or regulations by any government, and so any travel cancellation or trip change claims related to this cause.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">12.</label>
								<label className="col-10 col-form-label">Would I be covered if I were booked on a holiday and then could not go because my employer needs me in Malaysia and cancels my leave application?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
                                The policy excludes trip cancellation claims caused by business obligations.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">13.</label>
								<label className="col-10 col-form-label">I am going overseas for training/ studying/ working/ charity for long period of time.  Can I purchase a travel insurance?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
                                No, our travel insurance is only meant for leisure or business purposes.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">14.</label>
								<label className="col-10 col-form-label">What is the use of trip cancellation insurance?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
                                This benefit compensates you for irrecoverable travel and accommodation expenses as a result of trip cancellation due to serious injury or illness.
								</label>
							</div>
						</div>

						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">15.</label>
								<label className="col-10 col-form-label">Is there any after sales & claims services offered to customer after insurance purchase?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
                                Yes, instaPol from Howden provides (1) Product Advisory, offering ongoing support to clients regarding insurance-related queries post-purchase (2) Assistance in changing / updating policy details (3) Claims assistance.  Alternatively, you may also contact your chosen insurance company or takaful operator.
								</label>
							</div>
						</div>

						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">16.</label>
								<label className="col-10 col-form-label">Is there any after sales & claims services offered to customer after insurance purchase?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								Yes, you may purchase insurance / takaful directly from any insurer or takaful operator by visiting their nearest branch or through their website.
								</label>
							</div>
						</div>
					</div>
					<div className="col-1"></div>
				</div>
			</div>
				
			<div className="row footer my-5">
				<div className="col-12 text-end">
					<a className="btn btn-success me-3" href="/Landing">Return to Home Page</a>
					<a className="btn btn-success" href="/Travel">Get Quote</a>
				</div>
			</div>
		</section>
	);
}